import type { UserDashboardApiEvent } from '#/modules/userDashboard/types/UserDashboardApiEvent';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  event: UserDashboardApiEvent;
};

function mapResponse(response: ApiResponse) {
  return response.event;
}

const endpoint = new FetchEndpoint({
  urlFactory: (eventId: string) => `/data/userdashboard/events/${eventId}`,
  mapResponse,
});

// Exports

export const userDashboardApiIsomorphicFetchEvent =
  endpoint.createIsomorphicFetchFn();

export const useUserDashboardApiFetchEvent = endpoint.createUseFetchHook();
